// Chart colour palettes. Four presets, no custom picker in v1.
//
// INNODIA brand is the default; the magenta sits at slot 1 so it lands on
// the largest slice in a desc-sorted chart, matching the brand's accent role
// on innodia.org. Sequential blues and monochrome navy are for cases where
// the buckets are ordered (e.g. age bands) and a categorical palette would
// imply false distinctness.

export type PaletteId = "innodia" | "categorical10" | "sequentialBlues" | "monochromeNavy";

export interface PaletteOption {
  id: PaletteId;
  label: string;
  colors: string[];
}

export const PALETTES: PaletteOption[] = [
  {
    id: "innodia",
    label: "INNODIA brand",
    colors: [
      "#1E295E", // navy-700
      "#e90062", // magenta-500
      "#6E9FE7", // sky-500
      "#F5A623", // gold
      "#14B8A6", // teal
      "#8B5CF6", // violet
      "#3a4a8a", // navy-500
      "#f48cb7", // magenta-300
      "#9bbef0", // sky-300
      "#777777", // neutral-600 (long-tail fallback)
    ],
  },
  {
    id: "categorical10",
    label: "Categorical 10",
    // ColorBrewer Set2 (extended). Colour-blind friendly, no implied order.
    colors: [
      "#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854",
      "#ffd92f", "#e5c494", "#b3b3b3", "#1f78b4", "#33a02c",
    ],
  },
  {
    id: "sequentialBlues",
    label: "Sequential blues",
    // ColorBrewer Blues 9-step, lightest first becomes darker as count
    // grows. Reverse-order so the biggest bucket gets the deepest blue.
    colors: [
      "#08306b", "#08519c", "#2171b5", "#4292c6", "#6baed6",
      "#9ecae1", "#c6dbef", "#deebf7", "#f7fbff", "#bdd7e7",
    ],
  },
  {
    id: "monochromeNavy",
    label: "Monochrome navy",
    colors: [
      "#1E295E", "#2c3b76", "#3a4a8a", "#5567a8", "#7889c3",
      "#9caadc", "#bcc7ea", "#d6def0", "#e6e9f3", "#f1f3f9",
    ],
  },
];

export function getPalette(id: PaletteId): string[] {
  return (PALETTES.find((p) => p.id === id) ?? PALETTES[0]).colors;
}

export function colorAt(palette: string[], idx: number): string {
  return palette[idx % palette.length];
}
